import * as types from './types'
import Api from '@/api'
import { session } from '@/util'

export default {
    // 应用状态的数据结构
    state: {
        info: {},
        menu:{},
        accesstoken: {},
        remandField: 'topTime3',

    },
    // 唯一允许更新应用状态的地方
    mutations: {
        /**
         * 存储信息
         */
        [types.LOGIN]: (state, user) => {
            state.info = user;
            session("user", user);
        },
        /**
         * 存储信息
         */
        [types.MENU]: (state, user) => {
            state.menu = menu;
            session('menu', menu);
        },
        /**
         * 存储Token
         */
        [types.TOKEN]: (state, token) => {
            state.accesstoken = token;
            session('token', token)
        },
        /**
         * 删除信息
         */
        [types.LOGOUT]: (state) => {
            state.accesstoken = {};
            state.info = {};
            session('token', '');
            session('user', '');
            session('defaultbookversion', '')
        }
    },
    // Getters 允许组件从 Store 中获取数据
    getters: {
        token: state => state.accesstoken,
        user: state => state.info,
        menu: state => state.menu,
        AuditUser: function(state) {
            return { userId: state.info.id, userName: state.info.name }
        },
        remandField: state => state.remandField
    },
    actions: {
        [types.REFRESH]({ commit }) {
            let local = session(types.LOCAL_TOKEN)
            if (local) {
                commit(types.TOKEN, local)
            }
        },
        // 获取用户信息
        [types.USERINFO]({ commit, state }) {
            return session('user');
        },
        // 登录
        [types.LOGIN]({ commit }, userInfo) {
            const username = userInfo.userName.trim()
            return new Promise((resolve, reject) => {
                Api.system.requestToken({ userName: username, password: userInfo.password,sysCode: "suguan" }).then(response => {

                    if(response.code==0)
                    {
                    let token = {
                        logintime: new Date(),
                        accesstoken: response.token
                    }
                    commit(types.TOKEN, token)
                    commit(types.LOGIN, response.data)

                   }
                   resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
         // 登录
         [types.MENU]({ commit }, userInfo) {
            const username = userInfo.userName.trim()
            return new Promise((resolve, reject) => {
                Api.system.requestToken({ userName: username, password: userInfo.password }).then(response => {
                    commit(types.MENU, response.data)
                    resolve(token)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登出
        [types.LOGOUT]({ commit, state }) {
            commit(types.LOGOUT)
        },
        // 登出
        // [types.TOKEN]({ commit, tokensession }) {
        //     console.log(tokensession);
        //     commit(types.TOKEN,tokensession)
        // }
    }
}



// WEBPACK FOOTER //
// ./src/stores/user.js